import React from 'react';

const SportTypePicker = ({ label = 'Preferred Sport', value = '', onChange }) => {
    const sportTypes = [
        { type: 'Surfing' },
        { type: 'Wind Surfing' },
        { type: 'Kite Surfing' },
        { type: 'Foil' },
        { type: 'Fishing' },
        { type: 'Crayfishing' },
        { type: 'Yachting' },
        { type: 'Sailing' },
        { type: 'Kayaking' },
        { type: 'Snorkeling' },
        { type: 'Wakeboarding' },
        { type: 'Bodyboarding' },
        { type: 'SUP' },
        { type: 'Skimboarding' },
        { type: 'Jet Skiing' },
        { type: 'Scuba Diving' },
        { type: 'Swimming' },
    ];

    // Convert comma-separated string to array
    const selectedSports = value ? value.split(',').map(s => s.trim()) : [];

    const handleToggle = (type) => {
        let newSelection;
        if (selectedSports.includes(type)) {
            // Remove the sport
            newSelection = selectedSports.filter(s => s !== type);
        } else {
            // Add the sport
            newSelection = [...selectedSports, type];
        }
        // Convert back to comma-separated string
        onChange(newSelection.join(','));
    };

    return (
        <div className="mb-6">
            <label className="block text-sm font-medium text-custom-light-grey mb-3">
                {label}
            </label>
            
            <div className="flex flex-wrap gap-1">
                {sportTypes.map(({type}) => {
                    const isSelected = selectedSports.includes(type);
                    
                    return (
                        <button
                            key={type}
                            type="button"
                            onClick={() => handleToggle(type)}
                            className={`
                                flex flex-col items-center justify-center
                                px-2 py-2 rounded
                                transition-all duration-150
                                flex-shrink-0 
                                border 
                                hover:bg-custom-charcoal
                                ${isSelected 
                                    ? 'text-custom-light-blue border-custom-light-blue bg-custom-charcoal' 
                                    : 'border-transparent hover:bg-custom-charcoal'
                                }
                            `}
                        >
                            <span className="text-xs font-semibold mt-0.5">{type}</span>
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default SportTypePicker;